<kion-checkout-header
  [addressUrl]="address"
  [deliveryUrl]="delivery"
  [paymentUrl]="payment"
  [summaryUrl]="summary"
></kion-checkout-header>
